"use client";

import { Button } from "@/components/ui/button";
import { useRouter } from "next/navigation";

export function ExitDraftModeButton() {
  const router = useRouter();
  const handleExit = async () => {
    await fetch("/api/preview?preview=false"); // Clears draft mode
    router.refresh();
  };

  return (
    <Button variant="destructive" onClick={handleExit}>
      Exit Preview Mode
    </Button>
  );
}
